import React, { useEffect, useState } from "react";
import EventDetails from "./EventDetails";
import GetTickets from "./GetTickets";
import { useLocation, useNavigate } from "react-router-dom";
import { fetch_all_events } from "../../actions/events/event";
import PageSkeleton from "../../components/skeletons/PageSkeleton";

function EventInnerPage() {
  const [switchTab, setSwitchTab] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  const [remainingTickets, setRemainingTickets] = useState(null);
  const currentUrl = window.location.href;
   const urlArray = currentUrl.split("/");
  const eventId = urlArray[urlArray.length - 1];
  console.log(eventId)

  useEffect(() => {
    if(eventData){
      console.log(eventData);
 
      setRemainingTickets(eventData?.ticketsRemaining);
    }
    // if(!eventId){
    //   navigate("../")
    // }
    console.log(eventId)

    
  }, [eventData]);

  useEffect(()=>{
    fetchEvents();
  },[])

  const fetchEvents = async()=>{
    try{
        const res = await fetch_all_events()
        console.log(res)
        if(res.data?.success){
          const obj = res.data?.data.find(item => item.id === parseInt(eventId));  // Find the object where id is 2

          setEventData(obj)
            console.log((obj) )
        }
    }catch(e){
        console.log(e)
    }
  }

  const updateTicketCount = (updatedCount) => {
    setRemainingTickets(updatedCount);
  };
  return (
    <div>
       { console.log(eventData)}

      {eventData  ? 
      <div>
      {switchTab == 1 ? (
        <EventDetails
          eventData={eventData}
          goToEvent={() => setSwitchTab(2)}
          remainingTickets={remainingTickets}
        />
      ) : (
        <GetTickets
          eventData={eventData}
          backToEvent={() => setSwitchTab(1)}
          remainingTickets={remainingTickets}
          updateTicketCount={(updatedCount) => updateTicketCount(updatedCount)}
        />
      )}
      </div> :
        <PageSkeleton type="page" />} 
    </div>
  );
}

export default EventInnerPage; 